module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAM1BMVEUAAAD///////////////////////////////////////////////////////////////+3leKCAAAAEXRSTlMA/xyb08+PECDv36/z17sw+3VakUsAAABtSURBVHgB7di7EYAwEAPRE39jY9N/tTRwwxAoINjXwGYKFPgTADIiQOArAgQAJKZ5kcG67ZE6ikzOvFBls0WmyGZlrl8QIECAAAECBAg02VyR6bKZIzNumZQpUqM3GZR6BIAMc02AAAG+awB4AIlEEXYbB+CUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stacked-icon.png
// module id = 57
// module chunks = 0